import { format, formatDistanceToNow, differenceInSeconds } from "date-fns";

export const SHORT_DATE_FORMAT = "MMMM yyyy";
export const STANDARD_DATE_FORMAT = "MMMM dd, yyyy";
export const SLASH_DATE_FORMAT = "M/dd/yy";
export const SLASH_DATE_TIME_FORMAT = "M/dd/yy - h:mm aaa";
export const SHORT_MONTH_FORMAT = "MMM";
export const DATE_TIME_FORMAT = "MMM d - h:mm aaa";
export const LONG_DATE_FORMAT = "MMMM d, yyyy h:mm a";

const isValidDate = (d) => {
    return d instanceof Date && !isNaN(d);
};

export const buildDateFromString = (str) => {
    if (!str) {
        return null;
    }
    try {
        const date = new Date(str);
        return isValidDate(date) ? date : null;
    } catch {
        return null;
    }
};

export const formatDate = (date, pattern = STANDARD_DATE_FORMAT) => {
    const stringDate = buildDateFromString(date);
    if (!stringDate) return "";
    try {
        return format(stringDate, pattern);
    } catch {
        return "";
    }
};

export const formatRecentDate = (date) => {
    const stringDate = buildDateFromString(date);
    return stringDate ? formatDistanceToNow(stringDate) : "";
};

export const getTTLFromExpTimestamp = (expTimestamp) => {
    if (!expTimestamp) {
        return 0;
    }
    try {
        const now = new Date();
        const futureDate = new Date(expTimestamp * 1000);
        const seconds = differenceInSeconds(now, futureDate) * -1;
        return seconds;
    } catch {
        return 0;
    }
};
